// IMPORTS:
let config = require(/*! ../config.js */"../config.js");
let UTILS = require(/*! ./utils.js */"./utils.js");
let THREE = require("three");
let overlay = {};

// CANVAS:
let canvas = overlay.canvas = document.getElementById("game-overlay");

// RESIZE:
function resize() {
  canvas.width = window.innerWidth;
  canvas.height = window.innerHeight;
}
window.addEventListener("resize", resize);
resize();

// IMAGES:
let flashImage = new Image();
let flashLoaded = false;
flashImage.onload = () => flashLoaded = true;
flashImage.src = "./img/muzflash.png";
let objectiveMarkerImage = new Image();
let objectiveMarkerLoaded = false;
objectiveMarkerImage.onload = () => objectiveMarkerLoaded = true;
objectiveMarkerImage.src = "./textures/objective_1.png";

// STATE:
overlay.showFlash = false;
overlay.flashX = 0;
overlay.flashY = 0;
overlay.crosshairType = 1;
overlay.crosshairColor = "white";
overlay.crosshairShadow = "black";
overlay.crosshairOpacity = 0;
overlay.crosshairScale = 0;
overlay.crosshairAlways = false;
overlay.dynamicHP = true;
overlay.crosshairStyle = 1;
overlay.crosshairThick = 2;
overlay.crosshairLen = 16;
overlay.crosshairImage = new Image();

// RENDER:
var tmpVector = new THREE.Vector3();
overlay.render = function (scale, Game, RENDER, player) {
  let ctx = canvas.getContext("2d");
  let o = overlay;
  let width = canvas.width / scale;
  let height = canvas.height / scale;
  let inGame = menuHolder.style.display == "none" && endUI.style.display == "none" && killCardHolder.style.display == "none";

  // SCALE:
  ctx.save();
  ctx.scale(scale, scale);

  // CLEAR:
  ctx.clearRect(0, 0, width, height);

  // DRAW USERNAMES:
  var tmpObj2 = RENDER.camera.getWorldPosition();
  if (menuHolder.style.display == "none" && endUI.style.display == "none") {
    // HIDE IF ON MENU:
    for (var i = 0; i < Game.players.list.length; ++i) {
      tmpObj = Game.players.list[i];
      if (!tmpObj.active) {
        continue;
      }
      if (tmpObj.isYou || !tmpObj.objInstances) {
        continue;
      }
      if (!tmpObj.inView) {
        continue;
      }

      // DETERMINE IF VISIBLE:
      var pos = tmpObj.objInstances.position.clone();
      pos.y += config.playerHeight + config.nameOffset - tmpObj.crouchVal * config.crouchDst;
      if (tmpObj.hatIndex >= 0) {
        pos.y += config.nameOffsetHat;
      }
      var dstDiv = Math.max(0.3, 1 - UTILS.getDistance3D(tmpObj2.x, tmpObj2.y, tmpObj2.z, pos.x, pos.y, pos.z) / 600);
      var fSize = 20 * dstDiv;
      var visible = fSize >= 1 && RENDER.frustum.containsPoint(pos);
      if (!visible) {
        continue;
      }
      ctx.save();

      // CET POST:
      pos.project(RENDER.camera);
      pos.x = (pos.x + 1) / 2;
      pos.y = (pos.y + 1) / 2;
      var tmpH = 14 * dstDiv;
      var tmpPad = 22 * dstDiv;

      // CENTER:
      ctx.translate(width * pos.x, height * (1 - pos.y));
      ctx.scale(dstDiv, dstDiv);

      // HEALTH BAR:
      let hbWidth = 120;
      let hbHeight = 16;
      ctx.fillStyle = "rgba(0, 0, 0, 0.4)";
      ctx.fillRect(-hbWidth / 2, -hbHeight, hbWidth, hbHeight);
      if (o.dynamicHP && tmpObj.hpChase > tmpObj.health) {
        ctx.fillStyle = "#FFFFFF";
        ctx.fillRect(-hbWidth / 2, -hbHeight, hbWidth * (tmpObj.hpChase / tmpObj.maxHealth), hbHeight);
      }
      var tmpTeam = player && player.team ? player.team : window.spectating ? 1 : 0;
      ctx.fillStyle = tmpTeam == tmpObj.team ? "#9eeb56" : "#eb5656";
      ctx.fillRect(-hbWidth / 2, -hbHeight, hbWidth * (tmpObj.health / tmpObj.maxHealth), hbHeight);

      // MEASURE TEXT:
      let username = tmpObj.name;
      let clan = tmpObj.clan ? `[${tmpObj.clan}]` : null;
      let rank = tmpObj.level;
      let normalFont = "20px GameFont";
      let rankFont = "30px GameFont";
      ctx.font = rankFont;
      let rankWidth = rank ? ctx.measureText(rank).width + 10 : 0;
      ctx.font = normalFont;
      let usernameWidth = ctx.measureText(username).width + (clan ? 5 : 0);
      let clanWidth = clan ? ctx.measureText(clan).width : 0;
      let totalWidth = rankWidth + usernameWidth + clanWidth;

      // DRAW TEXT:
      ctx.translate(0, -hbHeight - 10);
      ctx.fillStyle = "white";
      ctx.font = rankFont;
      if (rank) {
        ctx.fillText(rank, -totalWidth / 2, 0);
      }
      ctx.font = normalFont;
      ctx.globalAlpha = 1.0;
      ctx.fillText(username, -totalWidth / 2 + rankWidth, 0);
      ctx.globalAlpha = 0.4;
      if (clan) {
        ctx.fillText(clan, -totalWidth / 2 + rankWidth + usernameWidth, 0);
      }
      ctx.restore();
    }
  }

  // DRAW OBJECTIVE MARKER:
  if (Game.mode && Game.mode.objective && inGame && Game.map.manager.objectives.length > 0) {
    var vis = true;
    var pos = Game.map.manager.objectives[Game.activeObjective];
    for (var i = 0; i < Game.map.manager.objectives.length; ++i) {
      tmpObj = Game.map.manager.objectives[i];
      if (i == Game.activeObjective && UTILS.pointInBox3D(tmpObj2.x, tmpObj2.y, tmpObj2.z, tmpObj)) {
        vis = false;
        break;
      }
    }
    if (pos && vis) {
      tmpVector.set(pos.x, pos.y + 7, pos.z);
      var dstDiv = Math.max(0.3, 1 - UTILS.getDistance3D(tmpObj2.x, tmpObj2.y, tmpObj2.z, tmpVector.x, tmpVector.y, tmpVector.z) / 600);
      var iconSize = 70 * dstDiv;
      var visible = iconSize >= 1 && RENDER.frustum.containsPoint(tmpVector);
      if (visible && objectiveMarkerLoaded) {
        tmpVector.project(RENDER.camera);
        tmpVector.x = (tmpVector.x + 1) / 2;
        tmpVector.y = (tmpVector.y + 1) / 2;
        let scale = iconSize / objectiveMarkerImage.width;
        ctx.save();
        ctx.translate(tmpVector.x * width, (1 - tmpVector.y) * height);
        ctx.scale(scale, scale);
        ctx.drawImage(objectiveMarkerImage, -objectiveMarkerImage.width / 2, -objectiveMarkerImage.height / 2);
        ctx.restore();
      }
    }
  }

  // DRAW FLASH:
  if (o.showFlash && flashLoaded) {
    let flashSize = width * 1.6;
    ctx.drawImage(flashImage, width * o.flashX - flashSize / 2, height * o.flashY - flashSize / 2, flashSize, flashSize);
  }

  // CROSSHAIRS:
  if (inGame && o.crosshairType > 0 && !window.spectating) {
    // MEASURE CROSSHAIR:
    let chs = o.crosshairScale;
    let cx = width / 2;
    let cy = height / 2;
    let ox = cx - chs / 2; // Origin X
    let oy = cy - chs / 2; // Origin Y

    let t = 4; // Thickness
    let l = 21; // Length
    let ct = o.crosshairThick; // Thickness
    let cl = o.crosshairLen; // Length
    let cdd = 6; // Center dot diameter

    let always = o.crosshairAlways; // && !(aimDot.style.opacity != "0" || aimRecticle.style.opacity != "0");

    // DRAW CROSSHAIRS:
    ctx.save();
    ctx.globalAlpha = o.crosshairType > 1 && always ? 1 : o.crosshairOpacity;
    if (o.crosshairType == 4) {
      //IMAGE
      ctx.translate(0, 0);
      ctx.beginPath();
      ctx.drawImage(o.crosshairImage, cx - o.crosshairImage.width / 2, cy - o.crosshairImage.height / 2);
    }
    if (o.crosshairType == 2 || o.crosshairType == 3) {
      if (o.crosshairStyle == 0) {
        fillShadowedRect(ctx, cx - ct * 0.50, cy - cl, ct, cl * 2);
        fillShadowedRect(ctx, cx - cl, cy - ct / 2, cl * 2, ct);
        fillShadowedRect(ctx, cx - ct * 0.50, cy - cl, ct, cl * 2, 1, false, false);
      } else {
        if (o.crosshairStyle == 1 || o.crosshairStyle == 2) {
          fillShadowedRect(ctx, ox + chs / 2 - cl * 2 / 2, oy + chs / 2 - cl * 2 / 2, cl * 2, cl * 2, ct / 2, true, true, o.crosshairStyle == 2);
        } else {
          if (o.crosshairStyle == 3 || o.crosshairStyle == 4) {
            fillShadowedRect(ctx, ox + chs / 2 - cl * 2 / 2, oy + chs / 2 - cl * 2 / 2, cl * 2, cl * 2, ct / 2, false, true, o.crosshairStyle == 4);
          }
        }
      }
    }
    ctx.globalAlpha = o.crosshairOpacity;
    if (o.crosshairType == 1 || o.crosshairType == 3) {
      fillShadowedRect(ctx, ox, oy + chs / 2 - t / 2, l, t); // Left
      fillShadowedRect(ctx, ox + chs - l, oy + chs / 2 - t / 2, l, t); // Right
      fillShadowedRect(ctx, ox + chs / 2 - t / 2, oy, t, l); // Top
      fillShadowedRect(ctx, ox + chs / 2 - t / 2, oy + chs - l, t, l); // Bottom
    }
    ctx.restore();
  }
  ctx.restore();
};
function fillShadowedRect(ctx, x, y, width, height, thick = 1, circle = false, shadow = true, fill = true) {
  // SHADOW:
  if (shadow) {
    ctx.save();
    let size = 2;
    fill ? ctx.fillStyle = overlay.crosshairShadow : ctx.strokeStyle = overlay.crosshairShadow;
    ctx.lineWidth = thick;
    ctx.globalAlpha *= 0.5;
    ctx.beginPath();
    if (circle) {
      ctx.ellipse(x + width / 2, y + height / 2, width / 2 + size, height / 2 + size, 0, 0, Math.PI * 2);
    } else {
      ctx.rect(x - size, y - size, width + size * 2, height + size * 2);
    }
    fill ? ctx.fill() : ctx.stroke();
    ctx.restore();
  }
  fill ? ctx.fillStyle = overlay.crosshairColor : ctx.strokeStyle = overlay.crosshairColor;
  ctx.lineWidth = thick;

  // BASE SHAPE:
  ctx.beginPath();
  if (circle) {
    ctx.ellipse(x + width / 2, y + height / 2, width / 2, height / 2, 0, 0, Math.PI * 2);
  } else {
    ctx.rect(x, y, width, height);
  }
  fill ? ctx.fill() : ctx.stroke();
}
module.exports = overlay;